export default function (response: any, defaultMsg: string) {
  let msg: any = '';
  if (response?.data?.errors) {
    const errors = response?.data?.errors;
    Object.keys(errors).forEach((key: any, idx: any) => {
      if (idx > 0) {
        msg += '<br />';
      }
      msg += `${errors[key]}`;
    });
  } else if (response?.data?.message) {
    msg += response?.data?.message;
  }

  return msg || defaultMsg;
}
